import { usePlatformData } from "../../hooks/usePlatformData";
import Dropdown from "../Dropdown";

interface DocumentPagesFilters {
  tags: string[];
}

export default function TagsFilter({
  filters,
  handleTagChange,
}: {
  filters: DocumentPagesFilters;
  handleTagChange: (value: string) => void;
}) {
  const { tags } = usePlatformData();

  return (
    <>
      {/* Tags Filter */}
      <div className="flex flex-col gap-2 justify-between">
        <label
          htmlFor="tags"
          className="block text-sm font-medium text-gray-700 dark:text-zinc-100 mb-1"
        >
          Tags
        </label>
        <Dropdown
          id="tags"
          value={""}
          onChange={handleTagChange}
          disabled={tags.isLoading}
          placeholder="Select a tag..."
          options={tags.data?.tags
            .sort((a, b) => a.localeCompare(b))
            .map((tag) => ({
              label: tag,
              value: tag,
              disabled: filters.tags.includes(tag),
            }))}
        />
        {tags.error && (
          <p className="mt-1 text-sm text-red-600">{tags.error.message}</p>
        )}
      </div>
    </>
  );
}
